import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CrudService, MessageService, Page, Search } from 'elbuild-ui-lib-core';
import { Tool, Toollog } from 'toolbandi-ui-lib';
import { forkJoin } from 'rxjs';
import { LabelType, Options } from 'ng5-slider';



@Component({
	selector: 'app-tool-activity-use',
	templateUrl: './tool-activity-use.component.html',
	styleUrls: ['./tool-activity-use.component.scss']
})
export class ToolActivityUseComponent implements OnInit {

	@Input() tool: Tool;
	toollogs: Toollog[];

	constructor(private crudService: CrudService<Toollog>,
		private messageService: MessageService,
		private translateService: TranslateService) { }

		ngOnInit() {
			if (this.tool) {
				this.loadToollogs();
			}
		}

		getSliderDayOptions(item: Toollog): Options {
			return {
				floor: 0,
				ceil: item.maxdays,
			};
		}

		getSliderPercOptions(item: Toollog): Options {
			return {
				floor: 0,
				ceil: 100,
				translate: (value: number, label: LabelType): string => `${value} %`
			};
		}

		loadToollogs() {
			const search = new Search(Toollog.TABLE);
			search.addSimpleFilter('toolid', this.tool.id);
			this.crudService.searchEntities(Toollog, Toollog.TABLE, search, new Page(100)).subscribe(result => {
				this.toollogs = result;
			}, error => {
				this.messageService.sendError(error.error.msg);
			});
		}

		save() {
			const calls = this.toollogs.map(tl => {
				if ( tl.days > tl.maxdays || tl.days < 0 || tl.useprecentage < 0 || tl.useprecentage > 100 ) {
					this.messageService.sendError(this.translateService.instant('labels.input-value-error'));
					throw new Error('Invalid input');
				}
				return this.crudService.saveEntity(Toollog, Toollog.TABLE, tl);
			});
			forkJoin(calls).subscribe(result => {
				console.log(result);
				this.messageService.sendSuccess(this.translateService.instant('labels.info-saved'), this.translateService.instant('labels.tool-use'));
			}, error => {
				this.messageService.sendError(error.error.msg);
			});
		}

	}

